<template>
  <section
    v-if="data && data.items && data.items.length"
    :id="data.id"
    class="bg-white"
  >
    <div
      class="container flex overflow-auto py-6 sm:justify-center sm:overflow-visible md:py-10"
    >
      <div
        v-for="(item, i) in data.items"
        :key="i"
        class="group relative mx-3 h-20 w-20 flex-none items-center md:mx-5"
      >
        <CdnImg
          v-if="item.image && item.image.src"
          :src="item.image.src"
          :alt="item.alt || item.name"
          :width="80"
          :height="80"
          class="h-full w-full object-contain"
          loading="lazy"
        />

        <div
          v-if="item.name"
          class="duration-250 translate-y-1/5 title invisible absolute left-1/2 top-0 z-10 min-w-[206px] -translate-x-1/2 rounded-lg bg-white p-4 text-center uppercase leading-none tracking-[0.12em] text-slate opacity-0 shadow-default transition delay-75 group-hover:-mt-2 sm:group-hover:visible sm:group-hover:-translate-y-full sm:group-hover:opacity-100"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>
